var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"floor"},[_vm._v(" 版权所有：中国（汕头）知识产权保护中心 | 技术支持：中国专利信息中心 | 粤ICP备2022044960号-1 ")])])
}]

export { render, staticRenderFns }